import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagComponent } from './tag.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';

@NgModule({
    imports: [CommonModule, FiProfileIconModule],
    declarations: [TagComponent],
    exports: [TagComponent],
})
export class FiTagModule {}
